module.exports = __webpack_public_path__ + "img/Gerardo Rodríguez_Director Comercial.004088f2.png";